export const PHONE_INITIAL_VALUE = '+7';
